var ChipsModule = (function () {
    function ChipsModule() {
    }
    return ChipsModule;
}());
export { ChipsModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/chips/chips.module.ts.pre-build-optimizer.js